/* ══════════════════════════════════════════════════════════════
   Kannada (kn) — ಕನ್ನಡ Translation File
   ══════════════════════════════════════════════════════════════ */

export const kn = {
    app: {
        name: 'ಇಂಡಿಯಾ ಮಾರ್ಕೆಟ್ ಮಾನಿಟರ್',
        tagline: 'AI-ಚಾಲಿತ ಭಾರತೀಯ ಮಾರುಕಟ್ಟೆ ಬುದ್ಧಿಮತ್ತೆ',
    },
    nav: {
        dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        strategy: 'ತಂತ್ರ',
        intelligence: 'ಬುದ್ಧಿಮತ್ತೆ',
        markets: 'ಮಾರುಕಟ್ಟೆಗಳು',
        indiaMap: 'ಭಾರತದ ನಕ್ಷೆ',
        ipoEarnings: 'IPO ಮತ್ತು ಆದಾಯ',
        backtest: 'ಬ್ಯಾಕ್‌ಟೆಸ್ಟ್',
        settings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
        search: 'ಕಂಪನಿ, ಸುದ್ದಿ ಹುಡುಕಿ…',
    },
    dashboard: {
        title: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        marketStatus: 'ಮಾರುಕಟ್ಟೆ ಸ್ಥಿತಿ',
        open: 'ತೆರೆದಿದೆ',
        closed: 'ಮುಚ್ಚಿದೆ',
        preOpen: 'ಪ್ರಿ-ಓಪನ್',
        holiday: 'ರಜೆ',
        strategyCard: 'ಇಂದಿನ ತಂತ್ರ',
        marketRadar: 'ಮಾರ್ಕೆಟ್ ರೇಡಾರ್',
        fiiDii: 'FII / DII ಹರಿವು',
        quickStats: 'ತ್ವರಿತ ಅಂಕಿಅಂಶಗಳು',
        newsTicker: 'ಆದ್ಯತೆ ಸುದ್ದಿ',
        liveTV: 'ಲೈವ್ ಟಿವಿ',
        viewDetails: 'ವಿವರಗಳು ನೋಡಿ →',
    },
    strategy: {
        title: 'ತಂತ್ರ',
        regime: 'ಮಾರುಕಟ್ಟೆ ರೀಜಿಮ್',
        regimeTypes: {
            trendingBull: 'ಏರುಮುಖ ಟ್ರೆಂಡ್',
            trendingBear: 'ಇಳಿಮುಖ ಟ್ರೆಂಡ್',
            sideways: 'ಸೈಡ್‌ವೇಸ್',
            highVol: 'ಹೆಚ್ಚಿನ ಅಸ್ಥಿರತೆ',
        },
        confidence: 'ವಿಶ್ವಾಸ',
        entry: 'ಎಂಟ್ರಿ',
        target: 'ಗುರಿ',
        stopLoss: 'ಸ್ಟಾಪ್ ಲಾಸ್',
        buy: 'ಖರೀದಿಸಿ',
        sell: 'ಮಾರಿ',
        hold: 'ಹೋಲ್ಡ್',
        featureImportance: 'ಫೀಚರ್ ಪ್ರಾಮುಖ್ಯತೆ',
        keyLevels: 'ಪ್ರಮುಖ ಮಟ್ಟಗಳು',
        support: 'ಸಪೋರ್ಟ್',
        resistance: 'ರೆಸಿಸ್ಟೆನ್ಸ್',
        currentPrice: 'ಪ್ರಸ್ತುತ ಬೆಲೆ',
    },
    intelligence: {
        title: 'ಬುದ್ಧಿಮತ್ತೆ',
        morningBrief: 'ಬೆಳಗಿನ ಸಾರಾಂಶ',
        priorityFeed: 'ಆದ್ಯತೆ ಫೀಡ್',
        sectorIntel: 'ವಲಯ ಬುದ್ಧಿಮತ್ತೆ',
        earningsTracker: 'ಆದಾಯ',
        eventTimeline: 'ಘಟನೆಗಳು',
        newsSearch: 'ಹುಡುಕಿ',
        bullish: 'ಏರುಮುಖ',
        bearish: 'ಇಳಿಮುಖ',
        neutral: 'ತಟಸ್ಥ',
    },
    markets: {
        title: 'ಮಾರುಕಟ್ಟೆಗಳು',
        indices: 'ಸೂಚ್ಯಂಕಗಳು',
        options: 'ಆಪ್ಷನ್ಸ್',
        sectors: 'ವಲಯಗಳು',
        commodities: 'ಸರಕುಗಳು',
        currency: 'ಕರೆನ್ಸಿ',
        breadth: 'ಬ್ರೆಡ್ತ್',
        advancing: 'ಏರುತ್ತಿರುವ',
        declining: 'ಇಳಿಯುತ್ತಿರುವ',
    },
    ipo: {
        title: 'IPO ಮತ್ತು ಆದಾಯ',
        dashboard: 'IPO ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        earningsTracker: 'ಆದಾಯ ಟ್ರ್ಯಾಕರ್',
        upcoming: 'ಮುಂಬರುವ IPO',
        subscribe: 'ಸಬ್‌ಸ್ಕ್ರೈಬ್',
        avoid: 'ತಪ್ಪಿಸಿ',
        revenue: 'ಆದಾಯ',
        verdict: 'ತೀರ್ಪು',
        beat: 'ಬೀಟ್',
        miss: 'ಮಿಸ್',
    },
    backtest: {
        title: 'ಬ್ಯಾಕ್‌ಟೆಸ್ಟ್',
        equityCurve: 'ಈಕ್ವಿಟಿ ಕರ್ವ್',
        riskMetrics: 'ರಿಸ್ಕ್ ಮೆಟ್ರಿಕ್ಸ್',
        monthlyReturns: 'ಮಾಸಿಕ ಆದಾಯ',
        tradeLog: 'ಟ್ರೇಡ್ ಲಾಗ್',
        totalReturn: 'ಒಟ್ಟು ಆದಾಯ',
        winRate: 'ಗೆಲುವಿನ ದರ',
    },
    map: {
        title: 'ಭಾರತದ ನಕ್ಷೆ',
        selectState: 'ರಾಜ್ಯ ಆಯ್ಕೆಮಾಡಿ',
        gdp: 'GDP',
        growth: 'ಬೆಳವಣಿಗೆ',
        keySectors: 'ಪ್ರಮುಖ ವಲಯಗಳು',
    },
    settings: {
        title: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
        language: 'ಭಾಷೆ',
        selectLanguage: 'ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ',
        darkMode: 'ಡಾರ್ಕ್ ಮೋಡ್',
        lightMode: 'ಲೈಟ್ ಮೋಡ್',
    },
    sectorRotation: {
        title: 'ವಲಯ ಬದಲಾವಣೆ',
        leading: 'ಮುಂಚೂಣಿ',
        weakening: 'ದುರ್ಬಲ',
        lagging: 'ಹಿಂದುಳಿದ',
        improving: 'ಸುಧಾರಣೆ',
    },
    election: {
        title: 'ಚುನಾವಣೆ ಪರಿಣಾಮ',
        upcomingElections: 'ಮುಂಬರುವ ಚುನಾವಣೆಗಳು',
        state: 'ರಾಜ್ಯ',
        historicalImpact: 'ಐತಿಹಾಸಿಕ ನಿಫ್ಟಿ ಪರಿಣಾಮ',
        avgReturn: 'ಸರಾಸರಿ ನಿಫ್ಟಿ ಆದಾಯ',
    },
    budget: {
        title: 'ಬಜೆಟ್ ಪರಿಣಾಮ',
        unionBudget: 'ಕೇಂದ್ರ ಬಜೆಟ್ 2026-27',
        daysLeft: '{{days}} ದಿನಗಳು ಬಾಕಿ',
        increase: 'ಹೆಚ್ಚಳ',
        decrease: 'ಕಡಿಮೆ',
    },
    common: {
        loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ…',
        error: 'ಏನೋ ತಪ್ಪಾಯಿತು',
        retry: 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
        noData: 'ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ',
        viewAll: 'ಎಲ್ಲಾ ನೋಡಿ',
        close: 'ಮುಚ್ಚಿ',
        save: 'ಉಳಿಸಿ',
        cancel: 'ರದ್ದು',
        crore: 'ಕೋಟಿ',
        lakh: 'ಲಕ್ಷ',
        rupee: '₹',
        disclaimer: 'ಇದು ಹಣಕಾಸು ಸಲಹೆ ಅಲ್ಲ. ಮಾಹಿತಿ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಮಾತ್ರ.',
    },
};
